import { useTranslation } from '@frontend/i18n';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { DialOptionInstruction } from '../types';
import { ReadOnlyInstructionField } from './read-only-instruction';

export const PhoneTreeInstructionField = ({
  instructionState,
  disabled = false,
}: {
  instructionState: DialOptionInstruction;
  disabled?: boolean;
}) => {
  const { t } = useTranslation('phone');
  const { navigate } = useSettingsNavigate();

  const handleLinkClick = () => {
    navigate({
      to: '/phone/phone-tree-quick-actions/:id',
      params: { id: instructionState.id },
    });
  };

  return (
    <ReadOnlyInstructionField
      instructionName={instructionState.name ?? t('Unknown Phone Tree')}
      iconName={'phone-tree'}
      instructionType={t('Phone Tree')}
      onLinkClick={disabled ? undefined : handleLinkClick}
    />
  );
};
